import { Component, Input, inject } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AppToastService } from 'app/core/services/app-toast.service';
import { isEmpty } from 'lodash-es';
import { MinimalClient } from '../../../core/models/minimal-client.model';
import { AuthenticationService } from 'app/core/services/authentication.service';
import { PrescriberIncorrectInformationRequestsService } from '../../../core/services/prescriber-incorrect-information-requests.service';
import { MinimalProvider } from 'app/core/models/minimal-provider.model';
import { FormsModule } from '@angular/forms';
import { PrescriberNameComponent } from '../prescriber-name/prescriber-name.component';
import { PrescriberOfficesScrollableComponent } from '../prescriber-offices-scrollable/prescriber-offices-scrollable.component';
import { AutoFocusDirective } from '../../directives/auto-focus.directive';

import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'app-prescriber-incorrect-information-prompt',
    templateUrl: './prescriber-incorrect-information-prompt.component.html',
    styleUrls: ['./prescriber-incorrect-information-prompt.component.scss'],
    imports: [FormsModule, PrescriberNameComponent, PrescriberOfficesScrollableComponent, AutoFocusDirective, MatIcon]
})
export class PrescriberIncorrectInformationPromptComponent {
  private modalService = inject(NgbModal);
  private authService = inject(AuthenticationService);
  private toastService = inject(AppToastService);
  private prescriberIncorrectInformationRequestsService = inject(PrescriberIncorrectInformationRequestsService);

  @Input() client: MinimalClient;
  @Input() relatedRecordType: string;
  @Input() relatedRecordId: number;
  @Input() provider: MinimalProvider;
  @Input() prescriberId: number;

  providerIncorrectInfoModalEnabled = false;
  submitting = false;
  comments: string;
  serverError = false;
  validationErrors = new Array<string>();

  constructor() {
    this.providerIncorrectInfoModalEnabled = !this.authService.isCaptureAdminUser;
  }

  openModal($event, content) {
    $event.preventDefault();
    this.modalService
      .open(content, { windowClass: 'wide' })
      .result.then(() => this.reset())
      .catch(() => this.reset());
  }

  reset() {
    delete this.comments;
    this.serverError = false;
    this.validationErrors = new Array<string>();
  }

  submit(modal) {
    if (!this.submitting && this.validate()) {
      this.submitting = true;

      const params = {
        clientId: this.client.id,
        relatedRecordType: this.relatedRecordType,
        relatedRecordId: this.relatedRecordId,
        prescriberId: this.prescriberId,
        comments: this.comments,
      };

      this.prescriberIncorrectInformationRequestsService.create(params).subscribe(
        () => {
          this.toastService.show('Information logged!', { cssClass: 'bg-success-subtle' });
          this.submitting = false;
          modal.close();
        },
        (err: HttpErrorResponse) => {
          this.serverError = true;
          this.submitting = false;
          console.error(err);
        }
      );
    }
  }

  private validate() {
    this.validationErrors = new Array<string>();

    if (isEmpty(this.comments)) {
      this.validationErrors.push('Comment is required.');
    }

    return this.validationErrors.length === 0;
  }
}
